import DOMPurify from "dompurify";
import { isHtml, isMarkdown, isJson, isUrl } from "@/lib/textUtils";
import MarkdownRenderer from "@/components/shared/MarkdownRenderer";
import UrlPreviewCard from "@/components/shared/UrlPreviewCard";

interface RichContentProps {
  content: string;
}

export function RichContent({ content }: RichContentProps) {
  if (isHtml(content)) {
    const cleanHtml = DOMPurify.sanitize(content, { USE_PROFILES: { html: true } });

    return (
      <div
        className="text-xs text-foreground/80 whitespace-pre-wrap break-words [&_*]:max-w-full"
        dangerouslySetInnerHTML={{ __html: cleanHtml }}
      />
    );
  }

  if (isMarkdown(content)) {
    return (
      <div className="overflow-hidden">
        <MarkdownRenderer content={content} />
      </div>
    );
  }

  if (isJson(content)) {
    try {
      const pretty = JSON.stringify(JSON.parse(content), null, 2);
      return (
        <pre className="text-[10px] text-foreground/70 font-mono whitespace-pre overflow-hidden leading-tight">
          {pretty}
        </pre>
      );
    } catch {
      // fallback to normal text if parsing fails
    }
  }

  if (isUrl(content)) {
    return (
      <div className="h-full py-1">
        <UrlPreviewCard url={content} compact />
      </div>
    );
  }

  return (
    <p className="text-xs text-foreground/80 whitespace-pre-wrap break-words">
      {content}
    </p>
  );
}
